import markerSDK, { type MarkerSdk } from '@marker.io/browser';

/** Klantpagina's (publieke link, tekenen, review) en de PDF-route die Puppeteer rendert. */
export const isCustomerFacingPath = (pathname = window.location.pathname) =>
  /^\/(q|countersign|review)\/|^\/quotes\/[^/]+\/pdf/.test(pathname);

let widget: MarkerSdk | null = null;
let customData: Record<string, string> | undefined;
const listeners = new Set<() => void>();

/** Marker.io feedbackwidget voor het team; niet op klantpagina's. */
export function loadMarkerWidget() {
  if (isCustomerFacingPath()) return;
  markerSDK
    .loadWidget({ project: '6ad9c32e18cb028d4bcbaccd' })
    .then((loaded) => {
      widget = loaded;
      if (customData) loaded.setCustomData(customData);
      listeners.forEach((listener) => listener());
    })
    .catch(() => {});
}

export const isMarkerAvailable = () => widget !== null;

/** Voor `useSyncExternalStore`: Marker laadt pas na de eerste render. */
export function subscribeMarker(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Gaat mee met elke Marker-melding, ook als die via de eigen knop van Marker start. */
export function setMarkerCustomData(data: Record<string, string>) {
  customData = data;
  widget?.setCustomData(data);
}

/** Opent Marker met een screenshot van het hele scherm. */
export function captureWithMarker(): Promise<void> {
  return widget ? widget.capture('fullscreen') : Promise.resolve();
}
